import { RequestedStatus } from "@classes-service-types/index";
import type { AddOnDropdownOption } from "./types";

export const ADD_ON_STATUS_DROPDOWN_OPTIONS: AddOnDropdownOption[] = [...Object.values(RequestedStatus), "Archived"];
export const ADD_ON_REQUESTS_ERROR_MESSAGE = "We couldn't load the add-on requests. Please try again.";
export const ADD_ON_ADD_ERROR_MESSAGE = "The request was not saved. Please try again.";
export const ADD_ON_STATUS_UPDATE_ERROR_MESSAGE = "The change was not saved. Please try again.";
